import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { IServiceTemplate } from '../../../../core/models/service-template/service-template.model';

@Component({
  selector: 'irembogov-template-configuration-header-widget',
  templateUrl: './template-configuration-header-widget.component.html',
  styleUrls: ['./template-configuration-header-widget.component.scss'],
})
export class TemplateConfigurationHeaderWidgetComponent {
  @Input() template: IServiceTemplate | null = null;
  @Input() readyForPublish = false;
  @Input() isProcessing = false;
  @Input() persistenceStatus = 'All changes saved';
  @Input() showBuilderVersionToggle = false;
  @Input() useV2Builder = true;

  @Output() OnPreviewClick = new EventEmitter<boolean>();
  @Output() OnSaveAndClose = new EventEmitter<void>();
  @Output() OnPublishTemplate = new EventEmitter<void>();
  @Output() toggleBuilderVersion = new EventEmitter<void>();

  constructor(private router: Router) {}

  onPreviewToggle(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (target) {
      this.OnPreviewClick.emit(target.checked);
    }
  }

  goBackToTemplates(): void {
    this.router.navigate(['/services/templates']);
  }
}
